import { gql } from '@apollo/client'

export const GET_MY_JOB_APPLICATIONS = gql`
  query (
    $query: String
    $isArchived: Boolean
    $limit: Int
    $jobReferenceClean: String
    $page: Int
    $id: ID
    $sort: AppliedJobsSort
    $direction: SortDirection
  ) {
    currentUserData {
      id
      jobApplications(
        query: $query
        isArchived: $isArchived
        limit: $limit
        jobReferenceClean: $jobReferenceClean
        page: $page
        id: $id
        sort: $sort
        direction: $direction
      ) {
        # Meta Data
        totalCount
        hasNextPage
        # Job Application Data
        id
        jobReferenceClean
        dateApplied
        archivedAt
        isArchived
        # Job Data
        expired
        jobReferenceClean
        location
        title
        city
        state
        zipVal
        country
        postedAt
        companyName
        body
        bodyPreview
        employmentType
        startDate
        salaryMin
        salaryMax
        fintrosJobUuid
        fintrosLink
        remote
        fintrosSalaryType
        postingDeadline
        jobBenefits
        formattedLocationVerbose
        formattedLocationAbbr
        formattedAddress
        latitude
        longitude
        jobDepartments
        currency
        fintrosCompanyUuid
        promoted
        streetAddress
        source
        enrichedSalaryMedianUsd
        enrichedSalaryLowUsd
        enrichedSalaryHighUsd
        enrichedSalaryMedianCad
        enrichedSalaryLowCad
        enrichedSalaryHighCad
        enrichedSalaryCount
        formattedLocationPermutations
        # Company Data
        companyAnonymizedName
        companyLogoUrl
        companyBannerUrl
        companyType
        companyIndustry
        companyDomain
        companyIsPublic
        companyDescription
        companyFoundingYear
        companyEmployeeCount
        companyDepartments
        isAnonymouslyApplied
        # Job Application Data
        jobApplicationStatus {
          acceptedChatDate
          appliedDate
          applicationStatus
          hiredDate
          invitedToChatDate
          rejectedChatDate
          viewedDate
        }
        jobApplicationQuestions {
          id
          question
          questionType
          answerChoices
          submittedAnswer
        }
      }
    }
  }
`

export const GET_DRAFT_APPLICATIONS = gql`
  query (
    $query: String
    $limit: Int
    $jobReferenceClean: String
    $page: Int
    $id: ID
    $sort: SavedJobsSort
    $direction: SortDirection
  ) {
    currentUserData {
      id
      draftApplications(
        query: $query
        limit: $limit
        jobReferenceClean: $jobReferenceClean
        page: $page
        id: $id
        sort: $sort
        direction: $direction
      ) {
        # ---meta data---
        hasNextPage
        totalCount
        # draft Data
        id
        createdAt
        # updatedAt
        jobReferenceClean
        # answeredQuestions
        # ---Job Data---
        expired
        jobReferenceClean
        location
        title
        city
        state
        # zipVal
        country
        postedAt
        companyName
        body
        bodyPreview
        employmentType
        # startDate
        salaryMin
        salaryMax
        # fintrosJobUuid
        # fintrosLink
        remote
        # fintrosSalaryType
        postingDeadline
        # jobBenefits
        # formattedLocationVerbose
        formattedLocationAbbr
        formattedAddress
        # latitude
        # longitude
        # jobDepartments
        currency
        fintrosCompanyUuid
        # promoted
        # streetAddress
        source
        # enrichedSalaryMedianUsd
        # enrichedSalaryLowUsd
        # enrichedSalaryHighUsd
        enrichedSalaryMedianCad
        enrichedSalaryLowCad
        enrichedSalaryHighCad
        enrichedSalaryCount
        # formattedLocationPermutations
        # ---Company Data---
        companyAnonymizedName
        companyLogoUrl
        companyBannerUrl
        # companyType
        companyIndustry
        companyDomain
        # companyIsPublic
        # companyDescription
        companyFoundingYear
        companyEmployeeCount
        companyDepartments
      }
    }
  }
`

export const GET_MY_SAVED_JOBS = gql`
  query (
    $query: String
    $limit: Int
    $jobReferenceClean: String
    $page: Int
    $id: ID
    $sort: SavedJobsSort
    $direction: SortDirection
  ) {
    currentUserData {
      id
      savedJobs(
        query: $query
        limit: $limit
        jobReferenceClean: $jobReferenceClean
        page: $page
        id: $id
        sort: $sort
        direction: $direction
      ) {
        # Saved Job Data
        id
        jobReferenceClean
        savedAt
        unsavedAt
        hasNextPage
        totalCount
        # Job Data
        jobBannerUrl
        expired
        jobReferenceClean
        location
        title
        city
        state
        # zipVal
        country
        postedAt
        companyName
        body
        bodyPreview
        employmentType
        # startDate
        salaryMin
        salaryMax
        # fintrosJobUuid
        # fintrosLink
        remote
        # fintrosSalaryType
        postingDeadline
        # jobBenefits
        # formattedLocationVerbose
        formattedLocationAbbr
        formattedAddress
        # latitude
        # longitude
        # jobDepartments
        currency
        fintrosCompanyUuid
        # promoted
        # streetAddress
        source
        # enrichedSalaryMedianUsd
        # enrichedSalaryLowUsd
        # enrichedSalaryHighUsd
        enrichedSalaryMedianCad
        enrichedSalaryLowCad
        enrichedSalaryHighCad
        enrichedSalaryCount
        # formattedLocationPermutations
        # Company Data
        companyAnonymizedName
        companyLogoUrl
        companyBannerUrl
        # companyType
        companyIndustry
        companyDomain
        # companyIsPublic
        # companyDescription
        companyFoundingYear
        companyEmployeeCount
        companyDepartments
      }
    }
  }
`

export const GET_SAVED_JOBS_DATA = gql`
  query {
    currentUserData {
      id
      savedJobs {
        id
        savedAt
        jobReferenceClean
      }
    }
  }
`

export const GET_APPLIED_JOBS_METADATA = gql`
  query (
    $query: String
    $isArchived: Boolean
    $limit: Int
    $jobReferenceClean: String
    $page: Int
    $id: ID
  ) {
    currentUserData {
      id
      jobApplications(
        query: $query
        isArchived: $isArchived
        limit: $limit
        jobReferenceClean: $jobReferenceClean
        page: $page
        id: $id
      ) {
        # Job Application Data
        id
        jobReferenceClean
        dateApplied
      }
    }
  }
`
export const GET_ALL_DRAFTS_META_DATA = gql`
  query {
    currentUserData {
      id
      draftApplications {
        id
        jobReferenceClean
      }
    }
  }
`

export const GET_CURRENT_JOB_APPLICATIONS = gql`
  query {
    currentUserData {
      id
      jobApplications(limit: 10) {
        id
        dateApplied
        archivedAt
        companyName
        companyUuid
        companyJobUuid
        companyJobScreeningQuestionType
        companyJobScreeningQuestion
        companyJobScreeningQuestionOrder
        candidateScreeningJobQuestionAnswer
        logoUrl
        remote
        title
      }
    }
  }
`

export const GET_DRAFT_BY_JOB_REFERENCE_CLEAN = gql`
  query ($jobReferenceClean: String) {
    currentUserData {
      id
      draftApplications(jobReferenceClean: $jobReferenceClean) {
        id
        answeredQuestions
        createdAt
        updatedAt
      }
    }
  }
`

export const GET_JOB_APPLICATION = gql`
  query ($applicationId: ID!) {
    currentUserData {
      id
      profileSnapshot(applicationId: $applicationId) {
        id
        firstName
        lastName
        summary
        profileLastUpdatedTimeAgo
        profileLastUpdatedAt
        phone
        countryCode
        socialLinks {
          id
          url
          socialLinkType
        }
        positionSnapshots: positions {
          id
          anonymizedFormattedCompanyName
          anonymizedFormattedDescription
          anonymizedFormattedTitle
          companyLookalikes
          companyAnonymizedName
          companyName
          title
          startMonth
          startYear
          endMonth
          endYear
          countryCode
          location
          description
        }
        educationSnapshots: educations {
          id
          anonymizedFormattedSchool
          school
          degree
          anonymizedFormattedDegree
          degreeMajor
          anonymizedFormattedDegreeMajor
          description
          anonymizedFormattedDescription
          sanitizedFormattedDate
          sanitizedFormattedLocation
          startYear
          endYear
          location
        }
        certificationSnapshots: certifications {
          id
          name
          endYear
          complete
          sanitizedFormattedName
          sanitizedFormattedDate
        }
        languageSnapshots: languages {
          id
          name
          fluencySnapshots: fluencies {
            id
            proficiencyType
            fluencyType
          }
        }
        resumeTemplateType
      }

      jobApplications(applicationId: $applicationId) {
        # Meta Data
        totalCount
        hasNextPage
        # Job Application Data
        id
        jobReferenceClean
        dateApplied
        archivedAt
        # Job Data
        expired
        jobReferenceClean
        location
        title
        city
        state
        zipVal
        country
        postedAt
        companyName
        source
        body
        bodyPreview
        employmentType
        startDate
        salaryMin
        salaryMax
        fintrosJobUuid
        fintrosLink
        remote
        fintrosSalaryType
        postingDeadline
        jobBenefits
        formattedLocationVerbose
        formattedLocationAbbr
        formattedAddress
        latitude
        longitude
        jobDepartments
        currency
        fintrosCompanyUuid
        promoted
        streetAddress
        source
        enrichedSalaryMedianUsd
        enrichedSalaryLowUsd
        enrichedSalaryHighUsd
        enrichedSalaryMedianCad
        enrichedSalaryLowCad
        enrichedSalaryHighCad
        enrichedSalaryCount
        formattedLocationPermutations
        # Company Data
        companyAnonymizedName
        companyLogoUrl
        companyBannerUrl
        companyType
        companyIndustry
        companyDomain
        companyIsPublic
        companyDescription
        companyFoundingYear
        companyEmployeeCount
        companyDepartments
        jobApplicationStatus {
          acceptedChatDate
          appliedDate
          applicationStatus
          hiredDate
          invitedToChatDate
          rejectedChatDate
          viewedDate
        }
        # Job Application Data
        jobApplicationQuestions {
          id
          question
          questionType
          answerChoices
          submittedAnswer
        }
      }
    }
  }
`

export const CREATE_JOB_APPLICATION = gql`
  mutation ($jobReferenceClean: String!, $jobScreeningAnswers: [JSON!]) {
    jobApplicationCreate(
      jobReferenceClean: $jobReferenceClean
      jobScreeningAnswers: $jobScreeningAnswers
    ) {
      status
      errors
      jobApplication {
        id
      }
    }
  }
`

export const ARCHIVE_JOB_APPLICATION = gql`
  mutation ($jobReferenceClean: String!) {
    jobApplicationArchive(jobReferenceClean: $jobReferenceClean) {
      jobApplication {
        # Job Application Data
        jobReferenceClean
        dateApplied
        archivedAt
      }
      errors
      status
      statusCode
    }
  }
`

export const UNARCHIVE_JOB_APPLICATION = gql`
  mutation ($jobReferenceClean: String!) {
    jobApplicationUnArchive(jobReferenceClean: $jobReferenceClean) {
      jobApplication {
        # Job Application Data
        jobReferenceClean
        dateApplied
        archivedAt
      }
      errors
      status
      statusCode
    }
  }
`

export const DELETE_DRAFT = gql`
  mutation ($jobReferenceClean: String!) {
    draftApplicationDelete(jobReferenceClean: $jobReferenceClean) {
      draftApplication {
        id
        answeredQuestions
        createdAt
        jobReferenceClean
        answeredQuestions
      }
    }
  }
`

export const SAVE_APPLICATION_AS_DRAFT = gql`
  mutation ($jobReferenceClean: String!, $answeredQuestions: [JSON!]) {
    draftApplicationCreate(
      jobReferenceClean: $jobReferenceClean
      answeredQuestions: $answeredQuestions
    ) {
      draftApplication {
        id
        answeredQuestions
        createdAt
        jobReferenceClean
        answeredQuestions
      }
    }
  }
`

export const UPDATE_APPLICATION_DRAFT = gql`
  mutation ($jobReferenceClean: String!, $answeredQuestions: [JSON!]) {
    draftApplicationUpdate(
      jobReferenceClean: $jobReferenceClean
      answeredQuestions: $answeredQuestions
    ) {
      draftApplication {
        id
        answeredQuestions
        createdAt
        jobReferenceClean
        answeredQuestions
      }
    }
  }
`

export const BULK_ARCHIVE_JOB_APPLICATIONS = gql`
  mutation ($jobReferenceCleans: [String!]!) {
    jobApplicationArchiveBulk(jobReferenceCleans: $jobReferenceCleans) {
      remainingJobReferenceCleans
      errors
      status
      statusCode
    }
  }
`

export const BULK_UNARCHIVE_JOB_APPLICATIONS = gql`
  mutation ($jobReferenceCleans: [String!]!) {
    jobApplicationUnArchiveBulk(jobReferenceCleans: $jobReferenceCleans) {
      remainingJobReferenceCleans
      errors
      status
      statusCode
    }
  }
`

export const SAVE_JOB = gql`
  mutation ($jobReferenceClean: String!) {
    savedJobSave(jobReferenceClean: $jobReferenceClean) {
      errors
      status
      statusCode
    }
  }
`

export const UNSAVE_JOB = gql`
  mutation ($jobReferenceClean: String!) {
    savedJobUnsave(jobReferenceClean: $jobReferenceClean) {
      errors
      status
      statusCode
    }
  }
`

export const BULK_UNSAVE_JOBS = gql`
  mutation ($unsavedJobIds: [ID!]!) {
    savedJobUnsaveBulk(unsavedJobIds: $unsavedJobIds) {
      remainingSavedJobIds
      errors
      status
      statusCode
    }
  }
`

export const CHECK_JOB_SAVED = gql`
  query ($jobReferenceClean: String!) {
    currentUserData {
      id
      savedJobs(jobReferenceClean: $jobReferenceClean) {
        id
        jobReferenceClean
        companyId
        saved
        savedAt
        unsavedAt
        title
        location
      }
    }
  }
`
